<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
  >
    <div slot="body">
      <bita-ibox>
        <div slot="body">
          <div v-if="isLoadingGrid" class="row justify-content-center">
            <div class="col-auto">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>

          <table class="table" v-else>
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">ایجاد کننده</th>
                <th scope="col">وضعیت</th>
                <th scope="col">عملیات</th>
                <th scope="col">تاریخ ایجاد</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in requestLogs" :key="index">
                <th scope="row" v-text="(index += 1)"></th>
                <td>{{ item.created_by }}</td>
                <td>{{ item.state }}</td>
                <td>{{ item.action }}</td>
                <td>{{ $getJalaliDateTime(item.created_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </bita-ibox>
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
  },
  data() {
    return {
      isLoadingModal: false,
      isLoadingGrid: false,
      requestLogs: [],
      gridColumns: [
        {
          field: "created_by",
          title: "ایجاد کنند",
          width: "110px",
        },
        {
          field: "state",
          title: "وضعیت",
          width: "110px",
        },
        {
          field: "action",
          title: "حالت بار",
          width: "110px",
        },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
          width: "100px",
        },
      ],
    };
  },
  methods: {
    readData(requestId) {
      this.isLoadingGrid = true;
      this.$persistClient("get", `requests/logs?requestId=${requestId}`)
        .then((res) => {
          this.requestLogs = res.data;
        })
        .catch(() => {
          this.requestLogs = [];
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
  },
};
</script>
